/* eslint-disable import/no-cycle */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import axios from 'axios';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import _ from 'lodash';
import moment from 'moment';
import htmlToFormattedText from 'html-to-formatted-text';
import {
  demoteMarginLeftInEditorState,
  demoteMarginLeftInHtml,
  ensureIndentInheritsFollowingStyles,
  findIntentionalWhitespaceRanges,
  normalizeEditorFontFamilyStyles,
  normalizeEditorFontSizeStyles,
  normalizeEditorWhitespace,
  prepareEditorStateForHtmlExport,
  promoteBlockFontSizeToInline,
} from './editorStateUtils';
import { safeWindowOpen } from './safeWindowOpen';
import * as Styles from '../../Modules/Display/invoice/Components/StyleConstant';

import * as constantMessageData from '../Errors/constantMessageData';
import * as AppConstants from '../AppConstants';
import * as serviceEndPoint from '../services/service';
import { clearReduxManufacturerSecondScreen } from '../../Modules/Maintain/Manufacturer/store/ManufacturerAction';
import { clearReduxLogCheckScreen } from '../../Modules/Tasks/LogCheck/store/Actions';
import { clearReduxSuspendedCheckScreen } from '../../Modules/Research/SuspendedChecks/store/Actions';
import { clearReduxMaintainCheckDetailScreen } from '../../Modules/Maintain/Check/store/actions';
import { clearReduxMaintainContractDetailScreen } from '../../Modules/Maintain/Contract/store/actions';
import { clearReduxProviderReviewSecondScreen } from '../../Modules/Tasks/ProviderReview/Store/actions';
import { clearReduxUnderThresholdInvDetailScreen } from '../../Modules/Research/UnderThresholdInvoices/store/Actions';
import { clearReduxForSystemLevelCommCorrespondence } from '../../Modules/System/commentsAndCorrespondence/store/Actions';
import { clearReduxForInvoiceAuditDetailScreen } from '../../Modules/Research/InvoiceAudits/store/Actions';
import { clearReduxDetailScreenUnitConversion } from '../../Modules/Maintain/unitConversion/store/actions';
import { clearReduxForFilterAndSort } from '../Table/store/Actions';
import { clearReduxforLinkNewDrugsToDrugFamily } from '../../Modules/Tasks/LinkNewDrugsToDrugFamily/store/action';
import { clearReduxUpdateGeneralParamScreen } from '../../Modules/System/UpdateParamGeneral/store/action';
import { clearReduxDisplayInvoiceDetailScreen } from '../../Modules/Display/invoice/store/actions';
import { clearReduxReminderRecipientsScreen } from '../../Modules/System/ReminderRecipients/store/Actions';
import { clearReduxUserDefaultScreen } from '../../Modules/System/UserDefault/store/actions';
import { clearReduxCodeTablesScreen } from '../../Modules/System/codeTables/store/actions';
import { clearReduxPriceTypeScreen } from '../../Modules/System/priceType/store/action';
import { clearReduxProviderDetailScreen } from '../../Modules/Display/Provider/store/action';
import { clearReduxForClaimSearchScreen } from '../../Modules/Display/Claim/store/action';
import { clearReduxForMaintainGroupScreen } from '../../Modules/Maintain/group/store/group-action';
import { clearReduxForMaintainClientScreen } from '../../Modules/Maintain/client/store/actions';
import { clearReduxForMaintainPlanScreen } from '../../Modules/Maintain/Plan/store/actions';
import { clearReduxNumberOfUnitSearchScreen } from '../../Modules/Maintain/NumberOfUnits/store/action';
import { setChangesDataList } from '../../Modules/Research/ClaimAudits/store/actions';
import dateFnsFormat from 'date-fns/format';
import {
  dispatchActiveInvoiceNumber,
  getRosiAllocatePaymentDetail,
  handleErrorMessageForAllocatePayment,
  setPerviousScreenReduxData,
} from '../../Modules/Tasks/AllocatePayments/store/Actions';
import { dispatchSaveDetailsResponse } from '../../Modules/Tasks/AllocatePayments/PQASTab/store/Actions';
import { getAllocatePaymentScreenData } from '../../Modules/Tasks/AllocatePayments/components/gridComponents/ROSIUtils';
import { useDispatch } from 'react-redux';

export const closeTab = (activeRoute, history, dispatch, redirectPath) => {
  if (dispatch) {
    dispatch(clearReduxForFilterAndSort(activeRoute));
    if (activeRoute === '/manufacturer-detail') {
      dispatch(clearReduxManufacturerSecondScreen());
    }
    if (activeRoute === '/log-check') {
      dispatch(clearReduxLogCheckScreen());
    }
    if (activeRoute === '/suspendedCheck') {
      dispatch(clearReduxSuspendedCheckScreen());
    }
    if (activeRoute === '/maintain-check') {
      dispatch(clearReduxMaintainCheckDetailScreen());
    }
    if (activeRoute === '/createContract') {
      dispatch(clearReduxMaintainContractDetailScreen());
    }
    if (activeRoute === '/providerReviewDetail') {
      dispatch(clearReduxProviderReviewSecondScreen());
    }
    if (activeRoute === '/viewUnderThresholdInvoice') {
      dispatch(clearReduxUnderThresholdInvDetailScreen());
    }
    if (activeRoute === '/providerDetails') {
      dispatch(clearReduxProviderDetailScreen());
    }
    if (activeRoute === '/claim' || activeRoute === '/selected-claim') {
      dispatch(clearReduxForClaimSearchScreen(activeRoute));
    }
    if (
      activeRoute === '/units-claim' ||
      activeRoute === '/units-selected-claim'
    ) {
      dispatch(clearReduxNumberOfUnitSearchScreen(activeRoute));
    }
    if (activeRoute === '/userDefault') {
      dispatch(clearReduxUserDefaultScreen());
    }
    if (activeRoute === '/codeTable') {
      dispatch(clearReduxCodeTablesScreen());
    }
    if (activeRoute === '/priceType') {
      dispatch(clearReduxPriceTypeScreen());
    }
    if (activeRoute === '/comment') {
      dispatch(clearReduxForSystemLevelCommCorrespondence());
    }
    if (activeRoute === '/invoiceAuditsDetail') {
      dispatch(clearReduxForInvoiceAuditDetailScreen());
    }
    if (activeRoute === '/group-maintain') {
      dispatch(clearReduxForMaintainGroupScreen(activeRoute));
    }
    if (activeRoute === '/createNewPlan') {
      dispatch(clearReduxForMaintainPlanScreen(activeRoute));
    }
    if (activeRoute === '/maintain') {
      dispatch(clearReduxForMaintainClientScreen(activeRoute));
    }
    if (activeRoute === '/reminderRecipients') {
      dispatch(clearReduxReminderRecipientsScreen());
    }
    if (activeRoute === '/unitConversion-detail') {
      dispatch(clearReduxDetailScreenUnitConversion());
    }
    if (activeRoute === '/linknewdrugstodrugfamily') {
      dispatch(clearReduxforLinkNewDrugsToDrugFamily());
    }
    if (activeRoute === '/updateGeneralParam') {
      dispatch(clearReduxUpdateGeneralParamScreen());
    }
    if (activeRoute === '/display-invoice') {
      dispatch(clearReduxDisplayInvoiceDetailScreen());
    }
    if (activeRoute === '/ClaimAuditViewDetails') {
      dispatch(setChangesDataList([]));
    }
  }
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const filtered = updateTabs?.filter((item) => {
    return item.navTo !== activeRoute;
  });
  localStorage.setItem('tabItemsData', JSON.stringify(filtered));
  if (redirectPath) {
    if (
      !(
        updateTabs?.filter((item) => {
          return item.navTo === redirectPath.navTo;
        })?.length > 0
      )
    ) {
      updateTabs.push({ navTo: redirectPath.navTo, value: redirectPath.value });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
    history.push({
      pathname: redirectPath.navTo,
    });
  } else {
    const filtered1 = updateTabs?.filter((item) => {
      return item.navTo !== activeRoute;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(filtered1));
    if (filtered1?.length > 0) {
      history.push({
        pathname: filtered1[filtered1.length - 1]?.navTo,
      });
    } else {
      history.push({
        pathname: '/dashboard',
      });
    }
  }
};

export const checkValueExists = (arrayValue, value) => {
  if (arrayValue && arrayValue.length > 0) {
    let flag = false;
    arrayValue.map((obj) => {
      if (obj.code === value) {
        flag = true;
      }
    });
    return flag;
  }
};
export const getLongDescription = (arrayValue, value) => {
  if (arrayValue && arrayValue.length > 0) {
    let longDescription = value;
    arrayValue.map((obj) => {
      const valDesc = `${obj.code}-${obj.description}`;
      if (
        obj.code === value ||
        valDesc === value ||
        obj.description === value
      ) {
        longDescription = obj.longDescription ? obj.longDescription : value;
      }
    });
    return longDescription;
  }
};

export const removeLeadingTrailingSpaces = (objectData) => {
  if (objectData) {
    Object.entries(objectData).map(([key, value]) => {
      if (typeof value === 'string' && value !== null) {
        objectData[key] = String(value).trim();
      }
    });
    return objectData;
  }
  return objectData;
};

// This Method will format Currency with Commas and $

export const currencyFormatter = (currency, sign) => {
  if (currency) {
    let sansDec = parseFloat(currency)?.toFixed(2);
    let formatted = sansDec?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (Math.sign(currency) === -1) {
      sansDec = Math.abs(currency)?.toFixed(2);
      formatted = sansDec?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `(${sign} ${formatted})`;
    }
    return `${sign} ${formatted}`;
  }
  return `${sign}0.00`;
};

export const filterFormatter = (value) => {
  if (value) {
    return value.toFixed(2);
  }
  return '0.00';
};

export const uraFormatter = (currency) => {
  if (currency) {
    let sansDec = parseFloat(currency)?.toFixed(6);
    let formatted = sansDec?.replace(/\B(?=(\d{7})+(?!\d))/g, ',');

    if (Math.sign(currency) === -1) {
      sansDec = Math.abs(currency).toFixed(6);
      formatted = sansDec?.replace(/\B(?=(\d{7})+(?!\d))/g, ',');
      return `(${formatted})`;
    }
    return `${formatted}`;
  }
  return '0.000000';
};

export const filterUraFormatter = (value) => {
  if (value) {
    return value.toFixed(6);
  }
  return '0.00';
};

export const unitsFormatter = (units) => {
  if (units) {
    if (Math.sign(units) === -1) {
      return '(' + `${Math.abs(units).toFixed(4)}` + ')';
    }

    return `${parseFloat(units)?.toFixed(4)}`;
  }
  return '0.0000';
};

// This Method will format Cell style based on the condition

export const cellStyleFormatter = (cellValue) => {
  if (cellValue) {
    if (Math.sign(cellValue) === -1) {
      return {
        color: 'red',
        'border-right-color': Styles.BorderColor,
        textAlign: 'right',
      };
    }
    return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
  }
  return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
};
export const convertQuaterFromDate = (date) => {
  if (
    date !== '' &&
    date.toUpperCase().includes('Q') &&
    date.toUpperCase().substring(1, 2) === 'Q'
  ) {
    const dateUpperCase = date ? date.toUpperCase() : '';
    const splitDate = date ? dateUpperCase.split('Q') : '';
    if (splitDate[1].length == 2 && date) {
      const currentYear = new Date().getFullYear();
      const getCurrentCentury = currentYear.toString().substring(0, 2);
      const formattedYear = getCurrentCentury.concat(splitDate[1]);
      const formattedMonth =
        splitDate[0] == 1
          ? '01'
          : splitDate[0] == 2
          ? '04'
          : splitDate[0] == 3
          ? '07'
          : splitDate[0] == 4
          ? '10'
          : '01';
      const day = '01';
      const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
      return formattedDate;
    }
    if (splitDate[1].length == 4 && date) {
      const formattedYear = splitDate[1];
      const formattedMonth =
        splitDate[0] == 1
          ? '01'
          : splitDate[0] == 2
          ? '04'
          : splitDate[0] == 3
          ? '07'
          : splitDate[0] == 4
          ? '10'
          : '01';
      const day = '01';
      const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
      return formattedDate;
    }
    return '';
  }
  return '';
};
// covert Date format to Quatre format
export const convertDateToQuatre = (date) => {
  return `${moment(new Date(date)).quarter()}Q${new Date(date).getFullYear()}`;
};

export const convertQuatreManufacturer = (date) => {
  if (
    date &&
    date.toUpperCase().includes('Q') &&
    date.toUpperCase().substring(1, 2) === 'Q'
  ) {
    const dateUpperCase = date ? date.toUpperCase() : '';
    const splitDate = date ? dateUpperCase.split('Q') : '';
    if (splitDate[1]?.length === 2 && date) {
      const currentYear = new Date().getFullYear();
      const getCurrentCentury = currentYear.toString().substring(0, 2);
      const formattedYear = getCurrentCentury.concat(splitDate[1]);
      const formattedMonth =
        splitDate[0] == 1
          ? '01'
          : splitDate[0] == 2
          ? '04'
          : splitDate[0] == 3
          ? '07'
          : splitDate[0] == 4
          ? '10'
          : '01';
      const day = '01';
      const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
      return formattedDate;
    }
    if (
      splitDate[1].length == 4 &&
      AppConstants.NUMBER_REGEX.test(splitDate[1]) &&
      date
    ) {
      const formattedYear = splitDate[1];
      const formattedMonth =
        splitDate[0] == 1
          ? '01'
          : splitDate[0] == 2
          ? '04'
          : splitDate[0] == 3
          ? '07'
          : splitDate[0] == 4
          ? '10'
          : '01';
      const day = '01';
      const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
      return formattedDate;
    }
    return '';
  }
  return '';
};
export const quarterFormatter = (value) => {
  return (
    value.match(/^[1234]\Q[12]\d{3}$/) !== null ||
    value.match(/^[1234]\Q[12]\d{1}$/) !== null ||
    value.match(/^[1234]\q[12]\d{3}$/) !== null ||
    value.match(/^[1234]\q[12]\d{1}$/) !== null
  );
};
export const validDate = (d, value, fealed) => {
  if (value === null && fealed === 'start') {
    return false;
  }
  if (value === null && fealed === 'end') {
    return true;
  }
  var isValidDate = false;
  if (Object.prototype.toString.call(d) === '[object Date]') {
    isValidDate = true;

    if (isNaN(d)) {
      // d.getTime() or d.valueOf() will also work
      // date object is not valid
      var isValidDate = false;
    } else {
      // date object is valid
      isValidDate = true;
    }
  }
  return isValidDate;
};
// value should be Date in format of MM/DD/YYYY
export const compareDatewithDefault = (value) => {
  if (Date.parse(value) - Date.parse('01/01/1991') > 0) return true;
  return false;
};

export const convertQuaterToDate = (date) => {
  const dateUpperCase = date ? date.toUpperCase() : '';
  const splitDate = date ? dateUpperCase.split('Q') : '';
  if (splitDate[1]?.length == 2 && date) {
    const currentYear = new Date().getFullYear();
    const getCurrentCentury = currentYear.toString().substring(0, 2);
    const formattedYear = getCurrentCentury.concat(splitDate[1]);
    const formattedMonth =
      splitDate[0] == 1
        ? '03'
        : splitDate[0] == 2
        ? '06'
        : splitDate[0] == 3
        ? '09'
        : splitDate[0] == 4
        ? '12'
        : '03';
    const day =
      splitDate[0] == 1
        ? '31'
        : splitDate[0] == 2
        ? '30'
        : splitDate[0] == 3
        ? '30'
        : splitDate[0] == 4
        ? '31'
        : '31';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  if (splitDate[1]?.length == 4 && date) {
    const formattedYear = splitDate[1];
    const formattedMonth =
      splitDate[0] == 1
        ? '03'
        : splitDate[0] == 2
        ? '06'
        : splitDate[0] == 3
        ? '09'
        : splitDate[0] == 4
        ? '12'
        : '03';
    const day =
      splitDate[0] == 1
        ? '31'
        : splitDate[0] == 2
        ? '30'
        : splitDate[0] == 3
        ? '30'
        : splitDate[0] == 4
        ? '31'
        : '31';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  return '';
};
export const convertFromDateToMMDDYYYY = (date) => {
  const splitDate = date ? date.split('/') : '';
  if (date && splitDate[1].length == 2) {
    const currentYear = new Date().getFullYear();
    const getCurrentCentury = currentYear.toString().substring(0, 2);
    const formattedYear = getCurrentCentury.concat(splitDate[1]);
    const formattedMonth = splitDate[0];
    const day = '01';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  if (date && splitDate[1].length == 4) {
    const formattedYear = splitDate[1];
    const formattedMonth = splitDate[0];
    const day = '01';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  return '';
};
export const convertToDateToMMDDYYYY = (date) => {
  const splitDate = date ? date.split('/') : '';
  if (splitDate[1].length == 2 && date) {
    const currentYear = new Date().getFullYear();
    const getCurrentCentury = currentYear.toString().substring(0, 2);
    const formattedYear = getCurrentCentury.concat(splitDate[1]);
    const formattedMonth = splitDate[0];
    const day = '31';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  if (splitDate[1].length == 4 && date) {
    const formattedYear = splitDate[1];
    const formattedMonth = splitDate[0];
    const day = '31';
    const formattedDate = formattedMonth.concat('/', day, '/', formattedYear);
    return formattedDate;
  }
  return '';
};

export const getMfgDetailsDataByPlan = (plan) => {
  let val;
  if (plan == 'FD' || plan == 'ST') {
    val = 'G';
  } else {
    val = 'C';
  }
  return val;
};

export const arrayMove = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
};
export const replaceCommaIntoWhiteSpace = (val) => {
  return val?.toString()?.replace(/\,/g, '');
};
// check amount with number and only allow 15 digit
export const checkIfAmountNum = (value) => {
  // const reg = /^[0-9]\d{0,12}(\.\d{1,2})?$/;
  const reg = /^-?[0-9]\d{0,12}(\.\d{1,2})?$/;
  return reg.test(replaceCommaIntoWhiteSpace(value));
};
export const convertPDFFromAPI = (responseAPI) => {
  const file = new Blob([responseAPI], { type: 'application/pdf' });
  const fileURL = window.URL.createObjectURL(file);
  const newWindow = safeWindowOpen(fileURL, '_blank');

  if (!newWindow) {
    window.URL.revokeObjectURL(fileURL);
    alert('Please allow popups for this site to view the report.');
  }
};
export const focusToNextRowFirstCol = (gridParams, columnIndex) => {
  setTimeout(() => {
    if (gridParams) {
      const firstEditCol =
        gridParams.columnApi.getAllDisplayedColumns()[columnIndex];
      gridParams.api.ensureColumnVisible(firstEditCol);
      gridParams.api.setFocusedCell(
        gridParams.api.getDisplayedRowCount() - 1,
        firstEditCol
      );
      gridParams.api.ensureIndexVisible(
        gridParams.api.getDisplayedRowCount() - 1,
        'bottom'
      );
    }
  }, 1000);
};
export const redirectURLLink = (
  navTo,
  value,
  history,
  dispatch,
  isReadOnly = false
) => {
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  const tabIndex = updateTabs.findIndex((tab) => tab.navTo === navTo);
  if (
    updateTabs.findIndex((item) => {
      return item.navTo === navTo;
    }) === -1
  ) {
    updateTabs.push({ navTo: navTo, value: value });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    updateTabs[tabIndex].value = value;
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  if (dispatch) {
    dispatch(clearReduxForFilterAndSort(navTo));
  }
  if (history) {
    history.push({ pathname: navTo, isReadOnly: isReadOnly });
  }
};

export const resetDirty = (path) => {
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const newObj1 =
    updateTabs &&
    updateTabs.length > 0 &&
    updateTabs?.map((item) => {
      if (item.navTo === path) {
        item.isFormSave = false;
        item.isFormDirty = false;
        item.isFormError = false;
      }
      return item;
    });
  localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
};

export const upperCaseFirstLetter = (string) =>
  `${string.slice(0, 1).toUpperCase()}${string?.slice(1)}`;

export const lowerCaseAllWordsExceptFirstLetters = (string) =>
  string?.replaceAll(
    /\S*/g,
    (word) => `${word?.slice(0, 1)}${word?.slice(1)?.toLowerCase()}`
  );

export const validateMaxLength = (num, maxLength, maxDecimal) => {
  if (num) {
    const validNumber = new RegExp(/^\d*\.?\d*$/);
    num = typeof num === 'number' ? num.toString() : num;
    if (!(validNumber.test(num) && num >= 0)) {
      return false;
    }
    if (num?.includes('.')) {
      const array = num?.split('.');
      if (array[0].length > maxLength || array[1].length > maxDecimal) {
        return false;
      }
      if (
        array[0].length === 0 &&
        (array[1] === '00' || array[1] === '0' || array[0].length === 0)
      ) {
        return Number(0).toFixed(2);
      }
      if (array[1].length > 0 && array[1] !== '00') {
        return false;
      }
      return true;
    }
    if (!num.includes('.')) {
      if (num.length <= maxLength) {
        return Number(num)?.toFixed(2);
      }
    } else {
      return false;
    }
  } else if (num === '') {
    return true;
  } else {
    return false;
  }
};

// regex to check its positive whole numbers or not
export const isNumeric = (value) => {
  return /^\d+$/.test(value);
};

// to validate the quarter value
export const quarterTest1 = /[1-4]{1}[qQ]{1}\d{4}$/;
export const quarterTest2 = /[1-4]{1}[qQ]{1}\d{2}$/;
// handing Quarter format
export const handleQuarterFormate = (value) => {
  const data = value;
  if (data) {
    const d = data?.toString()?.split('');
    if (d) {
      d.splice(4, 0, 'Q');
    }
    const d1 = d?.join('').split('Q').reverse('');
    d1.splice(1, 0, 'Q');
    const output = d1?.join('');
    return output;
  }
};
// for richeditor convert html to blockmap data
export const EDITOR_TAB_WIDTH = 4;

// html-to-draftjs converts &nbsp; back to regular spaces before parsing.
const HTML_NBSP_ENTITY = '&#160;';

/** Replace persisted non-breaking-space entity variants with regular spaces. */
const replacePersistedNbspEntities = (value) =>
  value
    .replace(/&amp;#x0*A0;/gi, ' ')
    .replace(/&amp;#160;/gi, ' ')
    .replace(/&#160;/gi, ' ')
    .replace(/&#160(?=[^\d;])/gi, ' ')
    .replace(/&#x0*A0;/gi, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ');

/** Reverse persisted &#160; spacing entities (iterates for nested encodings). */
export const decodePersistedHtmlWhitespaceForEmail = (html) => {
  if (!html || typeof html !== 'string') {
    return html || '';
  }

  let result = html;
  let previous;
  do {
    previous = result;
    result = replacePersistedNbspEntities(result);
  } while (result !== previous);

  return result;
};

/** Decode common HTML entities left in plain-text email bodies (e.g. &gt; → >). */
const decodeCommonHtmlEntitiesForEmail = (value) => {
  if (!value || typeof value !== 'string') {
    return value || '';
  }

  let result = value;
  let previous;
  do {
    previous = result;
    result = result
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/&apos;/gi, "'")
      .replace(/&#x27;/gi, "'")
      .replace(/&#x2[Ff];/gi, '/');
  } while (result !== previous);

  // Numeric entities except NBSP (160) — handled separately as spaces
  result = result.replace(/&#(?!160\b)(\d+);/g, (match, code) => {
    const charCode = Number(code);
    return Number.isFinite(charCode) ? String.fromCharCode(charCode) : match;
  });
  result = result.replace(/&#x(?!0*A0\b)([0-9a-fA-F]+);/gi, (match, hex) => {
    const charCode = parseInt(hex, 16);
    return Number.isFinite(charCode) ? String.fromCharCode(charCode) : match;
  });

  return result;
};

/**
 * Soft-wrap plain text at word boundaries so email clients don't break mid-word.
 * Does not alter spacing within a line beyond inserting newlines.
 */
const softWrapPlainTextAtWordBoundaries = (text, maxLineLength = 100) => {
  if (!text || typeof text !== 'string') {
    return text || '';
  }

  return text
    .split('\n')
    .map((line) => {
      if (line.length <= maxLineLength) {
        return line;
      }

      const parts = line.split(/(\s+)/);
      let current = '';
      const lines = [];

      parts.forEach((part) => {
        if (!part) {
          return;
        }
        if (current.length === 0) {
          current = part;
          return;
        }
        if (current.length + part.length <= maxLineLength) {
          current += part;
          return;
        }
        if (/^\s+$/.test(part)) {
          lines.push(current);
          current = '';
          return;
        }
        lines.push(current.replace(/\s+$/, ''));
        current = part.replace(/^\s+/, '');
      });

      if (current) {
        lines.push(current.replace(/\s+$/, ''));
      }
      return lines.join('\n');
    })
    .join('\n');
};

/**
 * Convert letter-template HTML to plain text for email (Send Letter).
 * - Decodes &#160; / &nbsp; to real spaces (same count) — never drops spacing
 * - Uses normal spaces so words wrap at boundaries (not mid-word)
 * - Does not affect Letter Template storage, print, or UI preview HTML
 */
export const convertHtmlToEmailPlainText = (html) => {
  if (!html || typeof html !== 'string') {
    return '';
  }

  // Private-use placeholder survives html-to-formatted-text; 1 entity → 1 space later
  const NBSP_PLACEHOLDER = '\uE000';

  let prepared = html
    .replace(/&amp;#x0*A0;/gi, '&#160;')
    .replace(/&amp;#160;/gi, '&#160;')
    .replace(/&amp;nbsp;/gi, '&nbsp;');

  prepared = prepared
    .replace(/&#160;/gi, NBSP_PLACEHOLDER)
    .replace(/&#x0*A0;/gi, NBSP_PLACEHOLDER)
    .replace(/&nbsp;/gi, NBSP_PLACEHOLDER)
    .replace(/\u00A0/g, NBSP_PLACEHOLDER);

  let text = htmlToFormattedText(prepared);

  // Restore every placeholder as a normal space (preserves indent + inter-word gaps)
  text = text.split(NBSP_PLACEHOLDER).join(' ');

  text = decodeCommonHtmlEntitiesForEmail(text);
  text = text.replace(/\u00A0/g, ' ');
  text = softWrapPlainTextAtWordBoundaries(text, 100);

  return text;
};

const convertWhitespaceRunToEntities = (value) =>
  value
    .replace(/[\r\n]/g, '')
    .replace(/\t/g, HTML_NBSP_ENTITY.repeat(EDITOR_TAB_WIDTH))
    .replace(/ /g, HTML_NBSP_ENTITY)
    .replace(/&nbsp;/gi, HTML_NBSP_ENTITY)
    .replace(/\u00A0/g, HTML_NBSP_ENTITY);

const isIndentOnlyTextSegment = (text) => {
  const stripped = text.replace(/[\r\n]/g, '');
  if (!stripped.length) {
    return false;
  }

  const normalized = stripped
    .replace(/&#160;/gi, 'X')
    .replace(/&nbsp;/gi, 'X')
    .replace(/\u00A0/g, 'X')
    .replace(/\t/g, 'X')
    .replace(/ /g, 'X');

  return /^X+$/.test(normalized);
};

/**
 * Encode only intentional whitespace as &#160; for DB/Preview.
 * Natural single spaces between words stay as regular spaces (word wrap).
 * Also demotes legacy single &#160;/nbsp between words back to normal spaces.
 */
const preserveTextWhitespace = (text) => {
  if (!text || !/[\s\t\u00A0]|&#160;|&nbsp;/i.test(text)) {
    return text;
  }

  // Normalize entity forms to \u00A0 so range detection is consistent
  let result = text
    .replace(/&#160;/gi, '\u00A0')
    .replace(/&nbsp;/gi, '\u00A0');

  if (isIndentOnlyTextSegment(result)) {
    return convertWhitespaceRunToEntities(result);
  }

  const intentionalRanges = findIntentionalWhitespaceRanges(result);

  [...intentionalRanges]
    .sort((left, right) => right.start - left.start)
    .forEach((range) => {
      const original = result.slice(range.start, range.end);
      const encoded = convertWhitespaceRunToEntities(original);
      result =
        result.slice(0, range.start) + encoded + result.slice(range.end);
    });

  // Leftover single NBSPs (and any \u00A0 not encoded) → normal word spaces
  result = result.replace(/\u00A0/g, ' ');

  return result;
};

/** Encode intentional space/tab spacing as &#160; entities in HTML text nodes. */
const preserveHtmlWhitespace = (htmlData) => {
  if (!htmlData) {
    return htmlData;
  }

  return htmlData.replace(/>([^<]*)</g, (match, text) => {
    const preserved = preserveTextWhitespace(text);
    return preserved === text ? match : `>${preserved}<`;
  });
};

/** Move gap whitespace (including after line breaks) into the following styled span. */
const mergeIndentThroughBreaksIntoStyledSpan = (htmlData) => {
  if (!htmlData) {
    return htmlData;
  }

  return htmlData.replace(
    /((?:<br\s*\/?>)*)((?:[\r\n\t \u00A0]|(?:&#160;|&nbsp;))+)(<span\s+style="[^"]*">)/gi,
    (match, breaks, indent, spanOpen) =>
      `${breaks}${spanOpen}${convertWhitespaceRunToEntities(indent)}`
  );
};

/** Move gap whitespace before a styled span into that span so html-to-draftjs keeps it. */
const mergeIndentIntoFollowingStyledSpan = (htmlData) => {
  if (!htmlData) {
    return htmlData;
  }

  return htmlData.replace(
    />(?:(?:&#160;|&nbsp;)+|[\r\n\t \u00A0]+)<span(\s+style="[^"]*">)/gi,
    (match, spanAttrs) => {
      const indent = match.slice(1, match.indexOf('<span'));
      const nbspEntities = convertWhitespaceRunToEntities(indent);
      if (!nbspEntities) {
        return match;
      }
      return `><span${spanAttrs}${nbspEntities}`;
    }
  );
};

/** Wrap remaining indent-only gaps (e.g. before plain text) in a span of &#160; entities. */
const wrapStandaloneIndentInSpans = (htmlData) => {
  if (!htmlData) {
    return htmlData;
  }

  return htmlData.replace(/>([^<]*)</g, (match, text) => {
    if (!isIndentOnlyTextSegment(text)) {
      return match;
    }
    const nbspEntities = convertWhitespaceRunToEntities(text);
    if (!nbspEntities) {
      return match;
    }
    return `><span>${nbspEntities}</span><`;
  });
};

/**
 * Persist intentional spacing as &#160; for Preview/PDF, keep natural word spaces.
 */
const normalizeHtmlIndent = (htmlData) => {
  let html = preserveHtmlWhitespace(htmlData);
  html = mergeIndentThroughBreaksIntoStyledSpan(html);
  html = mergeIndentIntoFollowingStyledSpan(html);
  html = wrapStandaloneIndentInSpans(html);
  // Only leftover unicode NBSPs (not intentional &#160; entities already written)
  html = html.replace(/\u00A0/g, HTML_NBSP_ENTITY);
  return html;
};

const prepareHtmlForDraftImport = (html) =>
  html
    .replace(/&amp;#160;/gi, HTML_NBSP_ENTITY)
    .replace(/&nbsp;/gi, HTML_NBSP_ENTITY)
    .replace(/\u00A0/g, HTML_NBSP_ENTITY);

export const convertHTMLtoBlockmap = (data) => {
  let html = demoteMarginLeftInHtml(data || '');
  html = normalizeHtmlIndent(html);
  html = prepareHtmlForDraftImport(html);
  const blocksFromHTML = htmlToDraft(html);
  const state = ContentState.createFromBlockArray(blocksFromHTML);
  let editorState = EditorState.createWithContent(state);
  editorState = demoteMarginLeftInEditorState(editorState);
  editorState = normalizeEditorFontFamilyStyles(editorState);
  editorState = normalizeEditorFontSizeStyles(editorState);
  editorState = promoteBlockFontSizeToInline(editorState);
  editorState = normalizeEditorWhitespace(editorState);
  editorState = ensureIndentInheritsFollowingStyles(editorState);
  return editorState;
};

// for richeditor convert blockmap to html data
export const convertBlockmaptoHTML = (editorState) => {
  const preparedEditorState = prepareEditorStateForHtmlExport(editorState);
  const rawContentState = convertToRaw(preparedEditorState.getCurrentContent());
  let htmlData = draftToHtml(rawContentState);
  htmlData = normalizeHtmlIndent(htmlData);
  htmlData = demoteMarginLeftInHtml(htmlData);

  return htmlData;
};

// get url link from arraybuffur data
export const convertPDFURLFromAPI = (responseAPI) => {
  const myURL = window.URL || window.webkitURL;
  const file = new Blob([responseAPI], { type: 'application/pdf' });
  const fileURL = myURL.createObjectURL(file);
  return fileURL;
};

export const formatPhoneNumber = (e) => {
  let formattedNumber;
  const { value } = e.target;
  const { length } = value;
  // Filter non numbers
  const regex = () => value?.replace(/[^0-9\.]+/g, '');
  // Set area code with parenthesis around it
  const areaCode = () => `(${regex()?.slice(0, 3)})`;

  // Set formatting for first six digits
  const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

  // Dynamic trail as user types
  const trailer = (start) => `${regex().slice(start, regex().length)}`;
  if (length < 3) {
    // First 3 digits
    formattedNumber = regex();
  } else if (length === 4) {
    // After area code
    formattedNumber = `${areaCode()} ${trailer(3)}`;
  } else if (length === 5) {
    // When deleting digits inside parenthesis
    formattedNumber = `${areaCode()?.replace(')', '')}`;
  } else if (length > 5 && length < 9) {
    // Before dash
    formattedNumber = `${areaCode()} ${trailer(3)}`;
  } else if (length >= 10) {
    // After dash
    formattedNumber = `${firstSix()}-${trailer(6)}`;
  }
  /*  const formattedObject = {
      target: { name: name, value: formattedNumber },
    }; */
  return formattedNumber;
};

// get random number
export const getRandomNumberByInput = (n) => {
  const crypto = window.crypto || window.msCrypto;
  const array = new Uint32Array(n);
  const num = crypto.getRandomValues(array);
  const rData = [];
  for (const num of array) {
    rData.push(num);
  }
  return rData;
};
// verify quarter value if valid or not
export const checkQuarterValidation = (value) => {
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if (format.test(value)) {
    return false;
  }
  const reTest = /[1-4]{1}[qQ]{1}\d{4}$/;
  const reTest2 = /[1-4]{1}[qQ]{1}\d{2}$/;
  if (
    (reTest.test(value) || reTest2.test(value)) &&
    value?.toUpperCase()?.split('Q')[0]?.length === 1
  ) {
    return true;
  }
  return false;
};

// to get plain quarter range values
export const getQuarterVals = (value) => {
  if (typeof value === 'string') {
    const newValue = value && value?.toString()?.toLowerCase();
    let newVal = newValue?.split('q');
    if (value.length <= 4) {
      let curtYears = moment().format('YYYY');
      curtYears = `${_.join(_.split(curtYears, '', 2), '')}${newVal[1]}`;
      newVal = `${curtYears}${newVal[0]}`;
    } else {
      newVal = newVal[1] + newVal[0];
    }
    return newVal;
  }
  return null;
};
export const getQtrValWithoutQ = getQuarterVals;

// compare quarter start and end if valid or not
export const compareQtrs = (qtr1, qtr2) => {
  // takes two args as qtr1 - startQuarter and qtr2 - endQuarter
  let pass = false;
  if (qtr2 && !_.isEmpty(qtr2)) {
    const firstQtrVal = getQuarterVals(qtr1);
    const endQtrVal = getQuarterVals(qtr2);

    pass = _.gt(firstQtrVal, endQtrVal);
  } else {
    pass = true;
  }

  return pass;
};

// function for date validation
export const isValidDate = (s) => {
  // Assumes s is "mm/dd/yyyy"
  if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(s)) {
    return false;
  }
  const parts = s.split('/').map((p) => parseInt(p, 10));
  parts[0] -= 1;
  const d = new Date(parts[2], parts[0], parts[1]);
  return (
    d.getMonth() === parts[0] &&
    d.getDate() === parts[1] &&
    d.getFullYear() === parts[2]
  );
};

//  function to convert date into quarter
export const isDateToQuarter = (param) => {
  const date = new Date(param);
  const quarter = parseInt(date.getMonth() / 3) + 1;
  const year = parseInt(date.getFullYear());
  return `${quarter}Q${year}`;
};

export const isCheckDateFormat = (value) => {
  const data = value?.toString()?.split('/');
  const regex = /^[0-9]+$/;
  let isValid = false;
  if (data.length === 3) {
    for (let i = 0; i < data?.length; i++) {
      if (!regex.test(data[i])) {
        isValid = true;
      }
    }
    if (!isValid) {
      let result;
      const year = data[2];
      const newDate = moment(value);
      const dateValidate = newDate.isValid();
      if (
        moment(value, 'MM/DD/YYYY', true).isValid() ||
        moment(value, 'MM/DD/YY', true).isValid()
      ) {
        result = moment(newDate).format('MM/DD/YYYY');
      } else {
        return false;
      }
      return result;
    }
  }
  return false;
};

// validate email id
export const emailValidation = (value) => {
  let testVal = false;
  if (value && value !== '') {
    testVal = /^[a-zA-Z0-9.-_]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(value);
  }
  return testVal;
};
// on scroll default top level page
export const handleScrollToEvent = () => {
  window.scrollTo(0, 0);
};
// check comment available on not for API service
export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// call API for dropdown list
export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_DROPDOWN, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// set comment icon on if corrLinkId and comment is available
export const handleExistingCommentList = async (data, dispatch, storeRedux) => {
  if (data && data?.length > 0) {
    let result = [];
    if (
      data &&
      data?.filter((x) => {
        return x.corrLinkId && x.corrLinkId !== 'new';
      })?.length > 0
    ) {
      result = await getExistingCorrLinkIds({
        corrLinkId: data
          ?.filter((x) => {
            return x.corrLinkId && x.corrLinkId !== 'new';
          })
          ?.map((item) => {
            return item.corrLinkId;
          }),
      });
    }
    const tempObj = data?.map((item) => {
      if (
        result &&
        result?.data?.filter((x) => {
          return x === item.corrLinkId && x.corrLinkId !== 'new';
        }).length > 0
      ) {
        item.ccCommentsExist = 1;
      } else {
        item.ccCommentsExist = 0;
      }
      return item;
    });
    // set Grid level comment Icon
    if (storeRedux === 'allList') {
      return tempObj;
    }
    if (storeRedux) {
      return dispatch(storeRedux(tempObj));
    }

    // set form Level comment Icon
    return tempObj[0];
  }
};

export const isOverlapQtr = (data, ind, val) => {
  const overlapData = data.filter((valObj, index) => {
    if (valObj.startQtr && valObj.endQtr && ind !== index + 1) {
      const startQtr = new Date(convertQuaterToDate(valObj.startQtr));
      const endQtr = new Date(convertQuaterToDate(valObj.endQtr));
      const enteredQtr = new Date(convertQuaterToDate(val));
      return enteredQtr >= startQtr && enteredQtr <= endQtr;
    }
  });
  return overlapData.length > 0;
};

export const addZeroes = (num) => {
  let value = Number(num);
  const res = num.split('.');
  if (res.length === 1 || res[1].length < 7) {
    value = value.toFixed(6);
  }

  return value;
};

export const decrementIncrementQtr = (qtr, bit) => {
  let year = parseInt(qtr?.substring(2), [0, 1000]);
  let q = parseInt(qtr?.charAt(0), [0, 1000]);
  if (bit === 0) {
    // Decrement the quarter value by 1 if bit is 0
    if (q === 1) {
      q = 4;
      year -= 1;
    } else q -= 1;
    const newQuarter = `${q}Q${year}`;
    return newQuarter;
  }
  if (q === 4) {
    q = 1;
    year += 1;
  } else q += 1;
  const newQuarter = `${q}Q${year}`;
  return newQuarter;
};

export const getCellValue = (cellValue) => {
  let formattedValue = '';
  if (cellValue) {
    formattedValue =
      parseFloat(cellValue) < 0
        ? `($ ${(parseFloat(cellValue) * -1).toFixed(2)})`
        : `$ ${parseFloat(cellValue).toFixed(2)}`;
  } else {
    formattedValue = `$ ${parseFloat(cellValue).toFixed(2)}`;
  }
  return formattedValue;
};

export const formatQuater = (quater) => {
  const getCurrentCentury = new Date()
    .getUTCFullYear()
    .toString()
    .substring(0, 2);
  const splitQuater = quater.toLowerCase().split('q');
  let returnQuater = quater;
  if (splitQuater.length === 2 && splitQuater[1].length === 2) {
    returnQuater = `${splitQuater[0]}Q${getCurrentCentury}${splitQuater[1]}`;
  }
  return returnQuater.toUpperCase();
};

export const validateQuarter = (quater) => {
  if (quater?.toLowerCase().includes('q')) {
    const splitYear = quater.toLowerCase().split('q');
    const checkQuater = splitYear[0] <= 4;
    if (
      checkQuater &&
      splitYear.length === 2 &&
      splitYear[0].length === 1 &&
      (splitYear[1].length === 2 || splitYear[1].length === 4)
    ) {
      return true;
    }
    return false;
  }
  return false;
};

// compare two array or obect and get true/false value as return (if both are same then return "true" else "false")
export const compareTwoArrayOrObjects = (arr1, arr2, key) => {
  if (!_.isEmpty(arr1) && !_.isEmpty(arr2)) {
    const res1 = [];
    _.forEach(arr1, (e1, i1) => {
      _.forEach(arr2, (e2, i2) => {
        if (e1?.[key] === e2?.[key]) {
          if (_.isObject(e1) && _.isObject(e2)) {
            if (!_.isEmpty(e1) && !_.isEmpty(e2)) {
              const res = compareTwoArrayOrObjects(e1, e2, key);
              res1.push(res);
            }
          } else if (i1 === i2) {
            if (_.isBoolean(arr1?.[i2]) && _.isBoolean(arr1?.[i2])) {
              const eb1 = arr1[i2] ? 1 : 0;
              const eb2 = arr2[i2] ? 1 : 0;
              res1.push(eb1 == eb2);
            } else {
              res1.push(arr1?.[i2] == arr2?.[i2]);
            }
          }
        }
      });
    });
    return !_.includes(res1, false);
  }
  return true;
};

// to check which properties differ from two arrays
export function checkDifferentProperties(arr1, arr2) {
  const result = [];

  arr1.forEach((obj1) => {
    const obj2 = arr2.find((obj) => obj.id === obj1.id);

    if (obj2) {
      for (const prop in obj1) {
        if (obj1[prop] !== obj2[prop]) {
          result.push({
            id: obj1.id,
            property: prop,
            value1: obj1[prop],
            value2: obj2[prop],
          });
        }
      }
    }
  });

  return result;
}

// This function sorts Negative decimals, Positive decimals, Whole numbers & Alphabets
export const sortComparator = (valueA, valueB) => {
  valueA = valueA?.replace(/\u0000/g, '');
  valueA = valueA?.replace(/\x00/g, '');
  valueB = valueB?.replace(/\u0000/g, '');
  valueB = valueB?.replace(/\x00/g, '');
  if (valueA == null) return -1;
  if (valueB == null) return 1;
  if (!valueA.substring || !valueB.substring) return valueA - valueB;
  if (valueA.length < 1 || valueB.length < 1) return valueA - valueB;
  if (!isNaN(valueA) && !isNaN(valueB)) {
    return Number(valueA) - Number(valueB);
  }
  return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
};
// remove white space in ndc string
export const removeWhiteSpaceForNDC = (val) => {
  return val?.toString()?.split('//')[0];
};

/** Normalize NDC for AG Grid text filter (strip //uuid, trim, lowercase). */
export const normalizeNdcForGridFilter = (val) => {
  if (val == null || val === undefined) return '';
  return removeWhiteSpaceForNDC(val).toString().trim().toLowerCase();
};

/**
 * AG Grid textMatcher for NDC columns (xxxxx-xxxx-xx).
 * Supports filter with or without dashes; strips internal //uuid suffix used in row data.
 */
export const ndcTextMatcher = ({ filterOption, value: val, filterText }) => {
  if (filterText == null || filterText === '') {
    return true;
  }
  const display = normalizeNdcForGridFilter(val);
  const needle = filterText.toString().trim().toLowerCase();
  const displayDigits = display.replace(/-/g, '');
  const needleDigits = needle.replace(/-/g, '');

  const matchOn = (haystack, n) => {
    switch (filterOption) {
      case 'contains':
        return haystack.includes(n);
      case 'notContains':
        return !haystack.includes(n);
      case 'equals':
        return haystack === n;
      case 'notEqual':
        return haystack !== n;
      case 'startsWith':
        return haystack.startsWith(n);
      case 'endsWith':
        return haystack.endsWith(n);
      default:
        return false;
    }
  };

  const dashMatch = matchOn(display, needle);
  const digitMatch = matchOn(displayDigits, needleDigits);

  switch (filterOption) {
    case 'notContains':
    case 'notEqual':
      return dashMatch && digitMatch;
    default:
      return dashMatch || digitMatch;
  }
};

// remove comma on number filed in export to pdf
export const removeCommaForNumberFiled = (val) => {
  return val?.toString()?.replace(/\,/g, '');
};
export const removeDoubleQueFiled = (val) => {
  let str = val?.toString();
  str = str?.toString()?.replaceAll(/\"/g, '');
  str = str?.toString()?.replaceAll(/\n/g, ' ');
  str = str?.toString()?.replaceAll(/\r/g, '');
  return str;
};
// remove comma on number filed in export to pdf
export const removeDollarForNumberFiled = (val) => {
  return val?.toString()?.replace(/\$/g, '');
};
// remove percentage on number filed in export to pdf
export const removePercentageForNumberFiled = (val) => {
  return val?.toString()?.replace(/\%/g, '');
};

// replace white space
export const replaceWhiteSpaceIntoString = (val) => {
  return val?.toString()?.replace(/\./g, '');
};
// currnecy format for input texbox with doller and commas
export const currentcyFormat = (price, sign = '$ ') => {
  if (price != 0 && price != '' && price != null) {
    const num = sign + price;
    return num.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

export const cloneArr = (arr) => {
  if (!Array.isArray(arr)) {
    return [];
  }
  if (arr.length === 0) {
    return [];
  }
  const clonedArr = _.cloneDeep(arr);
  return clonedArr;
};

export const isArr = (arr) => {
  if (!Array.isArray(arr)) {
    return false;
  }
  if (arr.length === 0) {
    return false;
  }
  return true;
};
// handle Move Column for Ag-grid table
export const handleOnColumnMoved = (gridRef) => {
  const cols = gridRef.current.columnApi?.getAllGridColumns();
  const tempObj = [];
  if (cols.length > 0) {
    cols.forEach((item) => {
      if (item?.colDef?.columnSpan) {
        const totalCol = item?.colDef?.columnSpan;
        tempObj.push(item?.colDef);
        for (let i = 1; i < totalCol; i++) {
          tempObj.push({
            headerName: '',
            field: '',
            removeColumn: true,
            minWidth: 1,
            resizable: false,
            editable: false,
            cellStyle:
              totalCol === 2 && i === 1 && item?.colDef?.lastColumn
                ? { 'border-right-color': Styles.BorderColor }
                : i === totalCol - 2 && item?.colDef?.lastColumn
                ? { 'border-right-color': Styles.BorderColor }
                : {},
          });
        }
      } else if (item?.colDef?.headerName) {
        tempObj.push(item?.colDef);
      }
    });
  }
  return gridRef.current.api.setColumnDefs(tempObj);
};

// refresh Cell after add/delete comment
export const handleRefreshCell = (gridParams) => {
  if (gridParams?.api) {
    setTimeout(() => {
      gridParams.api.refreshCells();
    }, 2000);
  }
};
export const handleCommaSeparatedAmount = (formattedValue) => {
  let amountVal = 0;
  if (formattedValue?.toString()?.includes('$')) {
    const amountStr = formattedValue?.toString()?.split('$')[1];
    amountVal = parseFloat(
      removeCommaForNumberFiled(amountStr)
    )?.toLocaleString('en-US');
  } else {
    amountVal = parseFloat(
      removeCommaForNumberFiled(formattedValue)
    )?.toLocaleString('en-US');
  }
  if (parseFloat(removeCommaForNumberFiled(amountVal)) > 0) {
    if (
      amountVal?.toString()?.includes('.') &&
      amountVal?.toString()?.split('.')[1]?.length === 1
    ) {
      return `$ ${`${amountVal}0`}`;
    }
    return `$ ${amountVal?.includes('.') ? amountVal : `${amountVal}.00`}`;
  }
  if (amountVal == 0) {
    return '$ 0.00';
  }
  return `$ ${parseFloat(formattedValue)?.toFixed(2)}`;
};
export const handleCommaSeparatedAmountWithoutDec = (formattedValue) => {
  let amountVal = 0;
  if (formattedValue?.toString()?.includes('$')) {
    const amountStr = formattedValue?.toString()?.split('$')[1];
    amountVal = parseFloat(removeCommaForNumberFiled(amountStr));
  } else {
    amountVal = parseFloat(removeCommaForNumberFiled(formattedValue));
  }

  const amountStrWithCommas = amountVal.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  if (amountVal > 0) {
    return `$ ${amountStrWithCommas}`;
  }

  if (amountVal === 0) {
    return '$ 0';
  }
  return `$ ${amountStrWithCommas}`;
};

export const convertCurrencyStringToNumber = (currencyStr) => {
  currencyStr = currencyStr.trim();
  const isNegative = currencyStr.startsWith('(') && currencyStr.endsWith(')');
  let cleanedStr = currencyStr.replace(/[^\d.-]/g, '');
  let number = parseFloat(cleanedStr);
  if (isNegative) {
    number = -number;
  }
  return number;
};
// press arrow down or arrow Up key then input textbox value selected.
export const handleOnKeyDownEventWithSelectValue = (e, inputId) => {
  if (
    e.key === 'ArrowDown' ||
    e.key === 'ArrowUp' ||
    e.key === 'Tab' ||
    e.key === 'Enter'
  ) {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    const timeId = setTimeout(() => {
      const input = document?.getElementById(inputId);
      if (input) {
        input.focus();
        input.select();
      }
      clearTimeout(timeId);
    }, 10);
  }
};

export const convertToMMDDYYYYFormat = (r) => {
  try {
    let m = [
      ...r.matchAll(
        /^(\d\d\d\d)[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])$/gim
      ),
    ];
    m.forEach((v, i) => {
      r = r.replace(v[0], `${v[2]}/${v[3]}/${v[1]}`);
    });
    m = [
      ...r.matchAll(
        /^(\d\d\d\d)[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])(T\d\d:\d\d:\d\d.\d\d\dZ)$/gim
      ),
    ];
    m.forEach((v, i) => {
      r = r.replace(v[0], `${v[2]}/${v[3]}/${v[1]}`);
    });
    m = [
      ...r.matchAll(
        /^(\d\d\d\d)[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])(T\d\d:\d\d:\d\d.\d\d\d\+\d\d\d\d)$/gim
      ),
    ];
    m.forEach((v, i) => {
      r = r.replace(v[0], `${v[2]}/${v[3]}/${v[1]}`);
    });
    m = [
      ...r.matchAll(
        /^(\d\d\d\d)[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])(T\d\d:\d\d:\d\d.\d\d\d\-\d\d\d\d)$/gim
      ),
    ];
    m.forEach((v, i) => {
      r = r.replace(v[0], `${v[2]}/${v[3]}/${v[1]}`);
    });
    return r;
  } catch (e) {
    return r;
  }
};
export const parseDate = (dt) => {
  if (!dt) {
    return dt;
  }
  if (new Date(dt).toString() == 'Invalid Date') {
    return dt;
  }
  if (!dt || (!(typeof dt == 'string') && typeof dt == 'object')) {
    return dateFnsFormat(dt, 'MM/dd/yyyy');
  }
  let cdt = convertToMMDDYYYYFormat(dt),
    split = cdt.split('/');
  if (split[2] < 100) {
    return new Date(new Date(cdt).setFullYear(split[2]));
  }
  return cdt;
};
export const redirectNewCombination = async (
  newTarget,
  history,
  dispatch,
  viewCheckAllocationDetail,
  searchScreenTabData,
  AllocatePaymentReducer
) => {
  if (!newTarget) return; // Prepare tab object for navigation

  const newObj = [
    {
      index: 0,
      invoiceNum: newTarget.invoiceNumber,
      checkLogNum: newTarget.checkNumber,
      active: true,
    },
  ]; // Optionally fetch details if needed (dispatch and other params must be provided)

  if (
    dispatch &&
    viewCheckAllocationDetail &&
    searchScreenTabData &&
    AllocatePaymentReducer
  ) {
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: newTarget.invoiceNumber,
        checkLogNum: newTarget.checkNumber,
        checkPayeeCD: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
        checkAmt:
          parseFloat(
            viewCheckAllocationDetail?.checkAmt?.toString().replace('$ ', '')
          ) || 0,
        mfgId: newTarget.mfgId,
        planType: newTarget.planType,
      })
    );
    dispatch(
      setPerviousScreenReduxData({
        ...searchScreenTabData,
        state: {
          ...searchScreenTabData.state,
          allocateFrom: 'Check',
        },
        selectedRow: {
          ...viewCheckAllocationDetail,
          checkPayeeCdVal: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
        },
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO).length
    ) {
      dispatch(dispatchActiveInvoiceNumber(newObj));
      const obj = { ...AllocatePaymentReducer?.detailScreenErrors };
      obj[
        `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
      ] = [];
      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: AllocatePaymentReducer?.searchScreenErrors
            ? AllocatePaymentReducer?.searchScreenErrors
            : [],
        })
      );
      dispatch(dispatchSaveDetailsResponse({}));
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } // Navigate to new tab
    if (history) {
      history.push({
        pathname: `/allocatePaymentDetail/${newTarget.checkNumber}-${newTarget.invoiceNumber}`,
      });
    }
  }
};
